import { type FilterValues } from '@ijoin/components';
import { useGetAdminPlanOptions } from '@ijoin/hooks';
import { Stack, Typography } from '@mui/material';
import { createFileRoute } from '@tanstack/react-router';

import { useState } from 'react';

import { ParticipantsGrid } from '../../components';
import { useAdvisoryOrganizationOptions } from '../../components/useAdvisoryOrganizationOptions';

const ParticipantsPage = () => {
  const [draftOrgId, setDraftOrgId] = useState<string>();

  const orgs = useAdvisoryOrganizationOptions();

  const plans = useGetAdminPlanOptions(
    { ...(draftOrgId && { advisoryOrganizationId: draftOrgId }) },
    {
      query: {
        select: res =>
          res.map(plan => ({
            label: plan.description ?? plan.planId,
            value: plan.planId
          }))
      }
    }
  );

  const onDraftChange = (values: FilterValues) =>
    setDraftOrgId((values.advisoryOrganizationId as string) || undefined);

  return (
    <Stack spacing={2} sx={{ height: '100%', p: 2 }}>
      <Typography variant='h5'>Participants</Typography>
      <ParticipantsGrid
        onDraftChange={onDraftChange}
        orgOptions={orgs.data ?? []}
        planOptions={plans.data}
      />
    </Stack>
  );
};

export const Route = createFileRoute('/participants/')({
  component: ParticipantsPage
});
